import React from 'react';
import { Layout, Button } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import './Footer.css';

const { Footer: AntFooter } = Layout;

const Footer = () => {
  const handleZaloClick = () => {
    // Thay đổi link Zalo này thành link Zalo của bạn
    window.open('https://zalo.me/your-zalo-id', '_blank');
  };

  return (
    <AntFooter className="app-footer">
      <div className="footer-content">
        <div className="footer-info">
          <p>&copy; 2025 Social Media Analytics - Phát triển bởi @huyit32</p>
        </div>
        <div className="footer-contact">
          <Button 
            type="primary" 
            icon={<MessageOutlined />}
            onClick={handleZaloClick}
            className="zalo-button"
          >
            Liên hệ Zalo
          </Button>
        </div>
      </div>
    </AntFooter>
  );
};

export default Footer;